const getGlobalConfig = (key: string, defaultValue: string) => {
    const config: {[configKey: string]: string} = (window as any).config;

    return !config || !config[key] || config[key] === `#{${key}}` ? defaultValue : config[key];
};

export const API_URL = getGlobalConfig('API_URL', 'http://localhost:18945');
export const ACS_WEBSITE = 'http://www.aircharter.co.uk/';
export const ACS_PRIVACY_POLICY = 'http://www.aircharterservice.com/legal-and-privacy-policy';
export const ONESIGNAL_APP_ID = getGlobalConfig('ONESIGNAL_APP_ID', '7d0dbcd6-b61c-456a-ac65-b76e1a7ae64e');
export const GOOGLE_ANALYTICS_ID = getGlobalConfig('GOOGLE_ANALYTICS_ID', '');
export const ALLOW_ALL_LOCALES = getGlobalConfig('ALLOW_ALL_LOCALES', 'true') === 'true';

/**
 * Current version of the app. N/A should be used
 * - for website
 * - for dev builds that don't want to interact with the update logic
 */
export const RELEASE_VERSION = getGlobalConfig('RELEASE_VERSION', 'N/A');

// URLs pointing to the Live JetPortal app within App Store or Google Play.
// These URLs use deep linking to point to the actual installed store applications instead of the corresponding websites.
export const APP_STORE_INTERNAL_URL = 'itms-apps://itunes.apple.com/app/id1444345237';
export const PLAY_STORE_INTERNAL_URL = 'market://details?id=com.aircharterservice.jetportal';

// Password strength is measured in zxcvbn score values ranging from 0 to 4.
// 2 is a "Fair" strength that is sufficient for throttled login API.
export const MINIMUM_PASSWORD_STRENGTH = 2;
export const MINIMUM_PASSWORD_LENGTH = 8;
